// components/FeedspaceWidget.tsx

"use client";

import Script from "next/script";


export default function FeedspaceTestimonialWidget({
  widgetId,
  className = "",
}) {
  return (
    <>
      <div className={`feedspace-embed ${className}`} data-id={widgetId} />

      <Script
        src={"https://js.feedspace.io/v1/embed/embed.min.js"}
        strategy="lazyOnload"
      />
    </>
  );
}